import { useQuery } from "@tanstack/react-query";
import { AccountOwnerOperation } from "src/Pages/Company/api/rechargePlanningSystem/rechargePlanningSystem.models";
import { fetchEmployeeOperations } from "src/Pages/Company/api/rechargePlanningSystem/clients";

const useRechargePlanningSystemData = (accountOwnerId: string, active: boolean) =>
  useQuery<AccountOwnerOperation[], Error>({
    queryKey: ["charge-ups-recharge-planning-system", accountOwnerId],
    queryFn: ({ signal }) => fetchEmployeeOperations(accountOwnerId, signal),
    enabled: active && !!accountOwnerId,
  });

export default useRechargePlanningSystemData;
